import { Outlet } from 'react-router-dom';

function Home() {
  
    return(
        <div>
        
        {/* <h1> Top Picks</h1> */}
        <Outlet />
        </div>
    )

}
export default Home;